import React, { PureComponent } from "react";
import KickImage from 'Reuseables/KickImage';
import PropTypes from "prop-types";
import classNames from "classnames";
import ShareSocialContainer from "../ShareSocialContainer";
import { getCacheImage } from "../../../../config";
import { getCloudImageUrl, emptyImage } from "../../../../utils";

const onErrorImg = (e, category) => {
  e.target.src = emptyImage(category)
}

export default class SmallThumbnails extends PureComponent {
  render() {
    if (this.props.thumbnails.length <= 1) return null;
    return (
      <div className="small-thumbnail-container">
        {this.props.thumbnails.map((item, index) => (
          <a
            href="#"
            onClick={e => this.props.goTo(e, index)}
            key={`data-small-thumbs-${index}`}
          >
            <div
              className={classNames("small-thumbnail-container__item", {
                active: this.props.active === index
              })}
            >
              <KickImage
                src={getCloudImageUrl(item.URL, 150)}
                alt={`${item.signed_url}`}
                onError={(e) => onErrorImg(e, this.props.category)}
              />
            </div>
          </a>
        ))}
      </div>
    );
  }
}
SmallThumbnails.propTypes = {
  thumbnails: PropTypes.array,
  altTitle: PropTypes.string
};
SmallThumbnails.defaultProps = {
  thumbnails: [],
  altTitle: ""
};
